import React from 'react';
import { useTranslation } from '../context/TranslationContext';
import { translateWithFallback } from '../utils/translateWithFallback';
import ProductSortDropdown from './ProductSortDropdown';
import { DEFAULT_PRODUCT_SORT, ProductSortKey } from '../utils/productSort';

type Props = {
    /** Total matching items (server total or client list length) */
    count: number;
    sort: ProductSortKey;
    onSortChange: (key: ProductSortKey) => void;
    /** Hide count while initial load (optional) */
    showCount?: boolean;
    className?: string;
};

/**
 * Figma results bar: "{count} items found" left, LanguageSwitcher-style sort right.
 */
const ProductResultsToolbar: React.FC<Props> = ({
    count,
    sort = DEFAULT_PRODUCT_SORT,
    onSortChange,
    showCount = true,
    className = '',
}) => {
    const { t } = useTranslation();
    const tr = (key: string, fb: string) => translateWithFallback(t, key, fb);

    const countLabel = tr('catalog.results.count', '{count} items found').replace(
        '{count}',
        String(count)
    );

    return (
        <div
            className={`mb-4 flex flex-wrap items-center justify-between gap-3 ${className}`}
        >
            <div className="min-w-0 flex-1">
                {showCount ? (
                    <p className="text-sm font-medium text-[var(--text-color)] sm:text-base">
                        {countLabel}
                    </p>
                ) : (
                    <span className="sr-only">{countLabel}</span>
                )}
            </div>
            <ProductSortDropdown value={sort} onChange={onSortChange} />
        </div>
    );
};

export default ProductResultsToolbar;
